import gsap from "gsap";
import _ from "underscore";

class ReadMore extends HTMLElement {

  constructor() {
    super();
  }


  connectedCallback() {
    this.active = false;
    this.toggle = this.querySelector('button');
    this.content = this.querySelector('.editor');
    this.contentHeight = this.content.clientHeight;

    this.content.style.height = 0;

    this.toggle.addEventListener('click', (event) => {
      event.preventDefault();
      // toggle active on click
      this.active = !this.active;
    });

    const debounceResize = _.debounce(() => {
      this.resizeHandler();
    }, 100);
    window.addEventListener('resize', (event) => {
      debounceResize()
    });
  }

  resizeHandler() {
    if (!this.active) {
      this.content.style.opacity = 0;
      this.content.style.height = 'auto';
      this.contentHeight = this.content.clientHeight;
      this.content.style.height = 0;
      this.content.style.opacity = 1;
    }
    else {
      this.contentHeight = this.content.clientHeight;
    }
  }



  get active() {
    return this.hasAttribute('active');
  }

  set active(val) {
    if (val && val != this.active) {
      this.setAttribute('active', 1);
    } else {
      this.removeAttribute('active');
    }
  }


  static get observedAttributes() {
    return ['active'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name == 'active') {
      // this.classList.toggle('active', !!newValue);
      this.toggle.ariaPressed = !!newValue;
      this.toggle.innerText = !!newValue ? 'Show less -' : 'Read more +';

      if (newValue) {
        // animate height to save value
        gsap.to(this.content, {
          height: this.contentHeight,
          duration: 0.25,
          ease: 'power1.inOut',
        });
      }
      else {
        // animate height 0
        gsap.to(this.content, {
          height: 0,
          duration: 0.25,
          ease: 'power1.inOut',
        });
      }
    }
  }
}


// Define the new web component
if ('customElements' in window) {
  customElements.define('read-more', ReadMore);
}
